import { isMobileEpgPath } from './is-mobile-epg';
import { loadSmartXPixel } from './smartx-pixel';

/**
 * Gets the consent string from OneTrust if available
 */
export function getConsentString(): string | undefined {
    if (typeof window === 'undefined') return undefined;
    const cookieVal = document.cookie.match(/(?:^|; )eupubconsent-v2=([^;]+)/)?.[1];
    return cookieVal;
}

export function injectOneTrust() {
    // Use official OneTrust otSDKStub with data-domain-script and OptanonWrapper
    const domainScriptId = window.APP_SETTINGS.oneTrustKey;
    const sdkUrl = window.APP_SETTINGS.oneTrustScriptUrl;
    // Don't inject OneTrust in embedded app
    const isApp = isMobileEpgPath();
    if (!domainScriptId || !sdkUrl || isApp) return;

    const script = document.createElement('script');

    script.src = sdkUrl;
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.setAttribute('data-domain-script', domainScriptId);

    document.head.appendChild(script);

    loadSmartXPixel();
}
